import Heart from "@/assets/svg/creator-shield/heart.svg";
import Recorder from "@/assets/svg/creator-shield/recorder.svg";
import Scissor from "@/assets/svg/creator-shield/scrissor.svg";

export default function WhatWeProtect() {
  const protections = [
    {
      icon: Recorder,
      title: "Full-Length Livestreams",
      description:
        "Every second of your live broadcasts automatically protected and monetized.",
      gradient: "bg-gradient-to-r from-[#9146ff] to-[#7b2fff]",
    },
    {
      icon: Scissor,
      title: "Clips & Highlights",
      description:
        "Your best moments deserve protection. We've got them covered.",
      gradient: "bg-gradient-to-r from-[#ff6b35] to-[#ff8c5f]",
    },
    {
      icon: Heart,
      title: "Viewer-Generated Clips",
      description:
        "Even clips created by your community are protected and monetized for you.",
      gradient: "bg-gradient-to-r from-[#ff0080] to-[#ff4081]",
    },
  ];

  return (
    <div id="what-we-protect" className="bg-white py-20 px-6 md:px-16">
      <div className="4xl:max-w-[100rem] 4xl:mx-auto">
        <div className="text-center mb-12 space-y-4">
          <p className="text-[#b380ff] font-semibold text-lg md:text-xl uppercase tracking-wide">
            WHAT WE PROTECT
          </p>
          <h2 className="text-5xl lg:text-6xl font-semibold text-black leading-normal">
            <span>Effortlessly </span>
            <span className="text-[#9146ff]">Protect & Earn</span>
            <span> From Your:</span>
          </h2>
        </div>

        <div className="flex flex-col gap-6 md:gap-[33px] max-w-4xl mx-auto">
          {protections.map((protection, index) => {
            return (
              <div
                key={index}
                className={`${protection.gradient} border border-[#ddd] rounded-[20px] h-full overflow-hidden flex flex-col gap-6 p-8 lg:p-10 transition-all duration-300 ease-out hover:-translate-y-1 hover:shadow-xl cursor-pointer`}
              >
                <div className="w-14 h-14 md:size-[60px]">
                  <img
                    src={protection.icon}
                    alt=""
                    className="block max-w-none size-full"
                  />
                </div>
               <div className="space-y-2">
               <h3 className="text-2xl md:text-3xl font-semibold text-white leading-normal">
                  {protection.title}
                </h3>
                <p className="text-lg font-normal text-white leading-[32px]">
                  {protection.description}
                </p>
               </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}

